<!-- TEMPLATE -->
<template >
  <div class="content" style="padding-top: 0px">
    <EmailStatistics />

    <PhishingEmailsDatatable />

    <br />
  </div>
</template>

<!-- SCRIPT -->
<script>
import PhishingEmailsDatatable from "./PhishingEmailsDatatable.vue";
import EmailStatistics from "./EmailStatistics.vue";
import TimeFilters from "./TimeFilters.vue";
import ExportReport from "./ExportReport.vue";

export default {
  name: "EmailContent",
  data: function () {
    return {
      userInfo: this.$store.state.cognitoInfo,
    };
  },
  computed: {},
  methods: {
    showAddPhishingDomainDialog() {
      this.show_add_phishing_domain_dialog = true;
    },
  },

  components: {
    PhishingEmailsDatatable,
    EmailStatistics,
    TimeFilters,
    ExportReport,
  },
};
</script>

<!-- Style -->
<style>
</style>